import React, { ReactNode } from 'react';
import Accordion from '../atoms/Accordion';

interface BlockProps {
	children: ReactNode;
}

const Block = (props: BlockProps) => {
	const { children } = props;
	return (
		<div className="grid-layout">
			<div className="col-span-full 2xl:col-span-10 2xl:col-start-2">
				<Accordion allowMultiple>{children}</Accordion>
			</div>
		</div>
	);
};

export default Block;
